import _ from 'lodash';
import { adapi, Debug, initDycolor } from '~';
import { mapActions, mapGetters } from 'vuex';
import { CLAIM_STATUS } from '@/util/constants';
import BoxWidget from '@/components/box-widget/BoxWidget.vue';
import FillStatus from '@/components/lab/fill-status/FillStatus.vue';

initDycolor('facebook-page-box', require(`${process.env.DYCOLOR_REQUIRE}./FacebookPageBox.scss`)); // eslint-disable-line

const debug = Debug('facebook-page');

const itemTemplate = {
  props: { item: { required: true } },
  template: `
    <div>
      <img :src='item.picture' />
      <div class="text">
        <span class="name">{{ item.name }}</span>
        <span class="link">{{ link }}</span>
      </div>
    </div>
  `,
  computed: {
    link() {
      if (!this.item || !this.item.link) {
        return '';
      }

      // remove https://www. (or as much of it as the original link has)
      // reduces the link length (and this is irrelevant info anyway)
      return this.item.link.replace(/^(?:https?:\/\/)?(?:www\.)?/, '');
    },
  },
};

export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.page || null,
      items: [],
      itemTemplate,
      claimsInProgress: 0,
      forceCancel: false,
    };
  },
  components: {
    'box-widget': BoxWidget,
    'fill-status': FillStatus,
  },
  methods: {
    ...mapActions('campaign', ['setFacebookPage', 'reloadCampaign']),
    showModal() {
      this.$refs.modal.show();
    },
    onUpdateItems(search) {
      debug.info('onUpdateItems: %s', search);
      return adapi.get('autocomplete/facebook-pages', { search })
        .then(items => items.map(i => Object.assign({}, i, { claim: CLAIM_STATUS.UNKNOWN })))
        .then(items => (this.items = items))
        .catch(err => debug.error(err));
    },
    onChange() {
      this.items = [];
    },
    clearSearch() {
      this.selected = null; // On first load user don't have page, so need to clear it
      this.$refs.autocomplete.searchText = null;
      this.onChange();
    },
    getLabel(item) {
      return _.get(item, 'name', null);
    },
    onConnect() {
      debug.info('onConnect. Selected: %o', this.selected);
      const fin = () => {
        this.claimsInProgress -= 1;
        this.$refs.modal.hide();
      };
      if (this.selected) {
        this.claimsInProgress += 1;
        this.setFacebookPage(this.selected.link)
          .then(() => fin())
          .then(() => this.reloadCampaign())
          .catch(e => {
            fin();
            this.$toast.error({ message: e });
          });
      }
    },
  },
  computed: {
    ...mapGetters('campaign', {
      campaign: 'currentCampaign',
      page: 'currentFacebookPage',
    }),
    disableConnect() {
      return !this.selected || !!this.claimsInProgress;
    },
    hasPage() {
      return !!this.page;
    },
    claimed() {
      return this.hasPage && this.page.claim === CLAIM_STATUS.CLAIMED;
    },
    claimLink() {
      if (!this.hasPage || this.page.claim !== CLAIM_STATUS.UNCLAIMED) {
        return false;
      }

      const pageLinkWithSlash = this.page.link.endsWith('/') ? this.page.link : `${this.page.link}/`;

      return `${pageLinkWithSlash}settings?tab=admin_roles`;
    },
    showClaimMessage() {
      return this.hasPage && !this.claimed && !this.claimsInProgress;
    },
    showClaimSuccess() {
      return this.hasPage && this.claimed && !this.claimsInProgress;
    },
    showInvitation() {
      return this.showClaimMessage && !this.forceCancel;
    },
    showCancel() {
      return !this.disableConnect && this.hasPage && !this.claimed && !this.forceCancel;
    },
    pageUrl() {
      return _.get(this.page, 'link', null);
    },
    readyForCAP() {
      return this.claimed ? 'success' : 'error';
    },
  },
  mounted() {
    this.selected = this.page;
    this.$refs.modal.$on('shown', () => {
      this.forceCancel = false;
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/facebook-page-box/FacebookPageBox.js